/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export default {
	state: () => ({
		assetManagementIsOpen: false,
		assetManagementMode: 0,
		assetManagementStationID: null,
		assetManagementEvent: null,
		assetManagementAsset: null,
		assetManagementParentEvent: null,
		assetManagementSelectedStation: null,
		assetManagementSelectedStationMarkers: [],
		assetManagementAllStationsList: [],
		assetManagementActiveStationsList: []
	}),

	getters: {
		assetManagementStationID: (state) => () => {
			return state.assetManagementStationID;
		},

		getAssetManagementEvent: (state) => () => {
			return state.assetManagementEvent;
		},

		getAssetManagementAsset: (state) => () => {
			return state.assetManagementAsset;
		},

		assetManagementIsOpen: (state) => () => {
			return state.assetManagementIsOpen;
		},

		getAssetManagementMode: (state) => () => {
			return state.assetManagementMode;
		},

		getAssetManagementParentEvent: (state) => () => {
			return state.assetManagementParentEvent
		},

		getAssetManagementSelectedStation: (state) => () => {
			return state.assetManagementSelectedStation;
		},

		getAssetManagementSelectedStationMarkersList: (state) => () => {
			return state.assetManagementSelectedStationMarkers;
		},

		getAssetManagementSelectedStationMarkers: (state) => () => {
			return state.assetManagementSelectedStationMarkers.find(sm => sm.stationID === state.assetManagementSelectedStation?.StationID)?.markers;
		},

		getAssetManagementSelectedStationName: (state) => () => {
			return state.assetManagementSelectedStationMarkers.find(sm => sm.stationID === state.assetManagementSelectedStation?.StationID)?.stationName;
		},

		getAssetManagementAllStationsList: (state) => () => {
			return state.assetManagementAllStationsList;
		},

		getAssetManagementActiveStationsList: (state) => () => {
			return state.assetManagementActiveStationsList;
		}
	},

	mutations: {
		setAssetManagementIsOpen(state, isOpen) {
			state.assetManagementIsOpen = isOpen;
		},

		setAssetManagementStationID(state, stationID) {
			state.assetManagementStationID = stationID;
		},

		setAssetManagementMode(state, mode) {
			state.assetManagementMode = mode;
		},

		setAssetManagementEvent(state, assetManagementEvent) {
			state.assetManagementEvent = assetManagementEvent;
		},

		setAssetManagementAsset(state, assetManagementAsset) {
			state.assetManagementAsset = assetManagementAsset;
		},

		setAssetManagementParentEvent(state, parentEvent) {
			state.assetManagementParentEvent = parentEvent;
		},

		clearAssetManagement(state) {
			state.assetManagementStationID = null;
			state.assetManagementEvent = null;
			state.assetManagementAsset = null;
			state.assetManagementParentEvent = null;
			state.assetManagementSelectedStation = null;
			state.assetManagementSelectedStationMarkers = [];
			state.assetManagementActiveStationsList = [];
		},

		closeAndResetAssetManagement(state) {
			state.assetManagementIsOpen = false;
			state.assetManagementMode = 0;
			state.assetManagementStationID = null;
			state.assetManagementEvent = null;
			state.assetManagementAsset = null;
			state.assetManagementParentEvent = null;
			state.assetManagementSelectedStation = null;
			state.assetManagementSelectedStationMarkers = [];
			state.assetManagementActiveStationsList = [];
		},

		setAssetManagementSelectedStation(state, station) {
			state.assetManagementSelectedStation = station;
		},

		setAssetManagementSelectedStationMarkers(state, {stationID, stationName, markers}) {
			let stationIndex = state.assetManagementSelectedStationMarkers.findIndex(sm => sm.stationID === stationID);
			if (stationIndex > -1) {
				state.assetManagementSelectedStationMarkers[stationIndex] = {
					stationID,
					stationName,
					markers
				};
			}
			else {
				state.assetManagementSelectedStationMarkers.push({
					stationID,
					stationName,
					markers
				});
			}
		},

		setAssetManagementAllStationsList(state, allStationsList) {
			state.assetManagementAllStationsList = allStationsList;
		},

		setAssetManagementActiveStationsList(state, ActiveStationsList) {
			state.assetManagementActiveStationsList = ActiveStationsList;
		}
	}
};
